export const navigationEvents = {
  header_navigation: "academy_header_navigation" as const,
  click_academy_header: "click_academy_header" as const,
  click_to_exchange: "click_to_exchange" as const,
};

export type NavigationEvents = typeof navigationEvents;
